module.exports = __webpack_public_path__ + "img/5-3-types-of-service.5e4c84fa.jpg";